export * from './lib/PropertyRecommendation/PropertyRecommendation.component';
